import { proxy, ref, snapshot, useSnapshot } from "valtio";
const store = proxy({
  sources: {},
  subscribers: {}
});
function resetStore() {
  store.sources = {};
  store.subscribers = {};
}
function subscribe(target, wormholeId) {
  store.subscribers[target] ??= /* @__PURE__ */ new Set();
  const activeSubs = store.subscribers[target];
  if (activeSubs.has(wormholeId)) {
    throw new Error(`Wormhole ${target} ${wormholeId} already exists`);
  }
  activeSubs.add(wormholeId);
}
function unsubscribe(target, wormholeId) {
  if (!store.subscribers[target]) return;
  store.subscribers[target].delete(wormholeId);
  if (store.subscribers[target].size === 0) {
    setTimeout(() => {
      if (!store.subscribers[target]) return;
      if (store.subscribers[target].size === 0) {
        closeWormhole(target, wormholeId);
      }
    }, 2e3);
  }
}
function getAllSubscribers() {
  return snapshot(store.subscribers);
}
function useSources(target) {
  const snap = useSnapshot(store.sources)[target] ?? [];
  return snap;
}
function getAllSources() {
  return store.sources;
}
function findWormhole(target, wormholeId) {
  if (store.sources[target]) {
    const idx = store.sources[target].findIndex((wormhole) => wormhole.id === wormholeId);
    if (idx === -1) return;
    return store.sources[target].at(idx);
  }
}
function openWormhole(target, wormholeId) {
  store.sources[target] ??= [];
  const idx = store.sources[target].findIndex((wormhole) => wormhole.id === wormholeId);
  if (idx === -1) {
    store.sources[target].push({
      id: wormholeId,
      worms: []
    });
  }
  return store.sources[target].at(idx);
}
function closeWormhole(target, wormholeId) {
  if (store.sources[target]) {
    const idx = store.sources[target].findIndex((wormhole) => wormhole.id === wormholeId);
    if (idx !== -1) {
      store.sources[target].splice(idx, 1);
    }
  }
  if (store.subscribers[target] === void 0 || store.subscribers[target].size === 0) {
    delete store.sources[target];
    delete store.subscribers[target];
  }
}
function getMeta(target, wormholeId) {
  const wormhole = findWormhole(target, wormholeId);
  return wormhole?.meta;
}
function setMeta(target, wormholeId, meta) {
  const wormhole = openWormhole(target, wormholeId);
  if (wormhole) {
    wormhole.meta = meta;
  }
}
function getPriority(target, wormholeId) {
  const wormhole = findWormhole(target, wormholeId);
  return wormhole?.priority;
}
function setPriority(target, wormholeId, priority) {
  const wormhole = openWormhole(target, wormholeId);
  if (wormhole) {
    wormhole.priority = priority;
  }
}
function addWorm(target, wormholeId, ...worms) {
  const wormhole = openWormhole(target, wormholeId);
  if (wormhole) {
    worms.forEach((worm) => {
      wormhole.worms.push(ref(worm));
    });
  }
}
function removeWorm(target, wormholeId, ...worms) {
  const wormhole = findWormhole(target, wormholeId);
  if (wormhole) {
    wormhole.worms = wormhole.worms.filter((x) => !worms.includes(x));
  }
}
function removeAllWorms(target, wormholeId) {
  const wormhole = findWormhole(target, wormholeId);
  if (wormhole) {
    wormhole.worms = [];
  }
}
export {
  addWorm,
  closeWormhole,
  findWormhole,
  getAllSources,
  getAllSubscribers,
  getMeta,
  getPriority,
  openWormhole,
  removeAllWorms,
  removeWorm,
  resetStore,
  setMeta,
  setPriority,
  subscribe,
  unsubscribe,
  useSources
};
//# sourceMappingURL=store.js.map
